var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('router-link',{class:[_vm.tabStatus],attrs:{"to":_vm.path},nativeOn:{"click":function($event){return _vm.onClick.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.title)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }